import { render, staticRenderFns } from "./domains.vue?vue&type=template&id=4c6075af&scoped=true"
import script from "./domains.vue?vue&type=script&lang=js"
export * from "./domains.vue?vue&type=script&lang=js"
import style0 from "./domains.vue?vue&type=style&index=0&id=4c6075af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6075af",
  null
  
)

export default component.exports